module.exports = __webpack_public_path__ + "img/Icon-Blue-01.74b8726a.png";